import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {AppStore} from '../../../../store/store';
import {SegmentValidationModel} from '../validation.model';
import {segmentValidationDeletedSelector, segmentValidationErrorSelector} from '../validation.reducer';
import {SegmentValidationService} from '../validation.service';
import {SubSink} from 'subsink';

@Component({
  selector: 'app-validation-delete',
  template: `
    <button mat-icon-button
            id="button-dialog-close"
            class="mat-icon-button-small"
            data-cy="button-dialog-close"
            mat-dialog-close>
      <mat-icon>clear</mat-icon>
    </button>
    <h5 mat-dialog-title>Delete Validation "{{validation?.name}}"</h5>
    <div mat-dialog-content class="mat-body-1">
      <p [hidden]="!errorMessage" id="error-feedback" class="error">{{errorMessage}}</p>
      <p>Do you really want to delete this validation?</p>
    </div>
    <div mat-dialog-actions>
      <button id="button-delete-cancel"
              name="cancel"
              color="primary"
              mat-raised-button
              mat-dialog-close>Cancel
      </button>
      <button data-cy="button-segment-delete-ok"
              id="button-delete-ok"
              name="ok"
              color="warn"
              mat-raised-button
              (click)="delete()">Delete
      </button>
    </div>
  `
})
export class SegmentValidationDeleteComponent implements OnInit, OnDestroy {

  subsink = new SubSink();
  validation!: SegmentValidationModel;
  errorMessage!: string;

  constructor(private appStore: AppStore,
              private dialogRef: MatDialogRef<SegmentValidationDeleteComponent>,
              private segmentValidationsService: SegmentValidationService) {
  }

  ngOnInit(): void {
    this.errorMessage = '';

    this.subsink.sink = this.appStore.subscribe((state: AppStore) => {
      // close dialog after successful delete

      if (segmentValidationDeletedSelector(state)) {
        this.dialogRef.close();
      }
      if (segmentValidationErrorSelector(state)) {
        this.errorMessage = 'Delete failed';
      } else {
        this.errorMessage = '';
      }
    });
  }

  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

  delete() {
    this.segmentValidationsService.deleteValidation(this.validation.id as number);
  }

}
